import {
    Alert, Button, Col, Container, FormControl, FormGroup, FormLabel, Modal, ModalFooter, Row, Spinner
} from "react-bootstrap";
import {useEffect, useRef, useState} from "react";
import axios from "axios";
import Helper from "../helper";
import {createUseStyles} from "react-jss";
import VideoItem from "../components/videoItem";
import VideoUploader from "../components/videoUploader";
import {useParams} from "react-router-dom";
import TopMenu from "../components/topMenu";
import {confirmAlert} from 'react-confirm-alert';

const useStyles = createUseStyles({
    thumbnail: {
        backgroundSize: 'cover'
    }
})

const Vimeo = () => {
    const classes = useStyles();
    const [videos, setVideos] = useState();
    const {courseID} = useParams();
    const [course, setCourse] = useState();
    const [videoRenameModal, setVideoRenameModal] = useState();
    const [renameForm, setRenameForm] = useState({
        name: '', description: ''
    });
    const watcher = useRef();

    const bc = useRef();

    useEffect(() => {
        let opener = window.opener
        bc.current = new BroadcastChannel("vimeo_channel_" + courseID);
        //////////////
        axios.get(Helper.VIMEO('course', [`id=${courseID}`])).then(res => {
            setCourse(res.data);
        });
        loadVideos();
        return () => {
            clearInterval(watcher.current);
        }
    }, []);

    const loadVideos = () => {
        axios.get(Helper.VIMEO('my-videos', [`course_id=${courseID}`])).then(res => {
            if (Array.isArray(res.data) && res.data.length > 0) {
                let _videos = res.data[0]?.videos || [];
                let notAvailableExisted = _videos.find(v => v.status != 'available');
                if (notAvailableExisted) {
                    watchVideoStatus();
                } else {
                    clearInterval(watcher.current);
                }
                setVideos([..._videos]);
            } else {
                setVideos([]);
            }
        })
    }

    const watchVideoStatus = () => {
        clearInterval(watcher.current);
        watcher.current = setInterval(() => {
            console.log('Reload videos');
            loadVideos();
        }, 10000);
    }

    const renameVideo = (video, e) => {
        axios.post(Helper.VIMEO('rename'), {
            video_id: video.id,
            course_id: courseID,
            name: renameForm.name || video.name,
            description: renameForm.description,
        }).then(res => {
            console.log(res.data);
            loadVideos();
        });
        setVideoRenameModal(void 0);
    }

    const deleteVideo = vid => {
        confirmAlert({
            title: 'Confirm to delete', message: 'Are you sure to delete this video?', buttons: [{
                label: 'Yes', onClick: () => {
                    setVideos(void 0);
                    axios.post(Helper.VIMEO('delete'), {
                        video_id: vid.id,
                        course_id: courseID,
                    }).then(res => {
                        loadVideos();
                    });
                }
            }, {
                label: 'No', onClick: () => {
                }
            }]
        });

    }

    return <Container>
        <h3 className='mt-4'>{course?.fullname || 'Loading...'}</h3>
        <Row>
            {course ? <VideoUploader courseID={course?.id} onFinished={() => {
                loadVideos();
            }}/> : <div className="text-center">
                <Spinner animation="border"/>
            </div>}
            {Array.isArray(videos) ? <>
                {videos?.length > 0 ? <>
                    {videos?.map(vid => <Col key={vid.id} sm={6} md={4} lg={3}>
                        <VideoItem video={vid}
                                   onUseVideo={() => {
                                       bc.current?.postMessage({video: vid});
                                   }}
                                   onEditVideo={() => {
                                       setRenameForm({
                                           name: vid.name, description: vid.description
                                       });
                                       setVideoRenameModal(vid);
                                   }}
                                   onDeleteVideo={() => {
                                       deleteVideo(vid);
                                   }}
                        />
                    </Col>)}
                </> : <Alert>No video in this course, Please upload a new one.</Alert>}
            </> : <Spinner animation='grow'/>}
        </Row>
        <Modal show={!!videoRenameModal} onHide={e => setVideoRenameModal(void 0)}>
            {videoRenameModal && <>
                <Modal.Header closeButton>
                    <Modal.Title>Rename Video: {videoRenameModal?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormGroup>
                        <FormLabel>Name</FormLabel>
                        <FormControl value={renameForm?.name} onChange={e => {
                            setRenameForm(old => ({
                                ...old, name: e.target.value
                            }))
                        }}/>
                    </FormGroup>
                    <FormGroup>
                        <FormLabel>Description</FormLabel>
                        <FormControl as="textarea" value={renameForm?.description} onChange={e => {
                            setRenameForm(old => ({
                                ...old, description: e.target.value
                            }))
                        }}/>
                    </FormGroup>
                </Modal.Body>
                <ModalFooter>
                    <Button variant="secondary" onClick={e => setVideoRenameModal(void 0)}>Cancel</Button>
                    <Button variant="primary" onClick={renameVideo.bind(this, videoRenameModal)}>Save</Button>
                </ModalFooter>
            </>}
        </Modal>
    </Container>
}
export default Vimeo;